{
  "page_visregisterinnsyn_title": "Innsyn",
  "innsyn_i_register": "Innsyn i",
  "default_error_title": "Det har skjedd en teknisk feil",
  "default_error_body": "Prøv igjen senere.",
  "innsyn_kan_ikke_lastes": "Innsyn kan ikke lastes",
  "innsynstype_innsyn": "Innsyn",
  "innsynstype_logg_over_bruk": "Logg over bruk",
  "innsynstype_logg_over_utlevering": "Logg over utlevering"
}
